const system_limit = {
    limit_exceeded: 'Vous avez atteint la limite du système. Veuillez contacter le support pour obtenir de l’aide.',
};
export default Object.freeze(system_limit);
